import { ref } from 'vue'

export const previousRoute      = ref({})